import { apiClient } from './client'

// ===========================
// USER PROFILE
// ===========================
export const userService = {
  // Get current user profile
  getProfile() {
    return apiClient.get('/me')
  },

  // Update current user profile
  updateProfile(payload) {
    return apiClient.put('/me', payload)
  },

  // Change password
  listTenantUsers(params) {
    const query = new URLSearchParams()
    if (params) {
      if (params.page) query.append("page", params.page)
      if (params.limit) query.append("limit", params.limit)
      if (params.query) query.append("query", params.query)
    }
    const qStr = query.toString()
    return apiClient.get(qStr ? `/users?${qStr}` : "/users")
  },

  changePassword(payload) {
    return apiClient.put('/me/password', payload)
  }
}

